import { useState, useEffect, useRef } from "react";
import { API_URL, isFieldError } from "../../../helpers";

import "./styles.css";

import Select from "../../../components/Select";
import Msg from "../../../components/Msg";
import Button from "../../../components/Button";

import Upload from "./Upload";
import Uploading from "./Uploading";
import Uploaded from "./Uploaded";

const HotelUploadForm = ({ token }) => {
	const [status, setStatus] = useState(3);
	const [names, setNames] = useState({});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [, setAlert] = useState({
		type: "working",
		text: "",
	});

	/* Status
      0 - Error
      1 - Uploaded
      2 - Uploading
      3 - Idle
    */

	const formElement = useRef(null);
	const dataFetchedRef = useRef(false);

	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		//init(token); not used, don't think we need this here

		// eslint-disable-next-line
	}, []);

	/*const init = async (token) => {
		const url = new URL(`${API_URL}/admin/batchInit`);
		const params = {
			token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames((names) => ({
					...names,
				}));
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};*/

	useEffect(() => {
		if (names.file) {
			formElement.current.dispatchEvent(
				new Event("submit", { cancelable: true, bubbles: true }),
			);
		}
	}, [names.file]);

	const handleUpdate = (name, value) => {
		if (name === "file") {
			if (value.size > 5000000) {
				setMsg({
					type: "error",
					text: "Please limit upload size to 5 MB.",
				});
				return false;
			} else {
				setStatus(2);
				setNames((names) => ({ ...names, [name]: value }));
			}
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		setErrors([]);

		const url = new URL(`${API_URL}/admin/hotelUploadBatch1`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.append("token", token);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("records", json.records);
				setStatus(1);
			} else {
				setStatus(3);
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setStatus(3);
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleReset = () => {
		setErrors([]);
		setMsg({});
		setStatus(3);
		formElement.current[0].selectedIndex = 0;
		setNames({});
	};

	return (
		<>
			<p>
				Use this page to perform a batch upload of confirmation numbers. The
				file processing script will attempt to validate the following
				attributes.
			</p>

			<div className="batch-box">
				<div style={{ paddingBottom: "10px" }}>
					<div className="full">
						<ul
							style={{
								marginTop: "15px",
								marginBottom: "0",
								paddingBottom: "0",
							}}
						>
							<li>Check that the input file type is of .csv format</li>
							<li>
								Check that the number of columns and column headings are correct
								against the pre-determined template
							</li>
							<li>
								Check that values in the request ID column are not empty and are
								valid
							</li>
							<li>
								Check that values in the request ID column still have approved
								status
							</li>
							<li style={{ paddingBottom: "0" }}>
								Check that the values in the confirmation number column are not
								empty
							</li>
						</ul>
					</div>
				</div>

				<form
					ref={formElement}
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					className="well upload-form"
					style={{ borderTop: "none" }}
				>
					<h3 style={{ marginTop: "0" }}>Upload Batch File</h3>

					<div className="form-group">
						<Select
							name="type"
							label="Select Hotel for Batch"
							reqd={true}
							value={""}
							options={[
								{ id: "", name: "--" },
								{ id: "jw", name: "JW Marriott" },
							]}
							update={handleUpdate}
							error={isFieldError(errors, "type")}
						/>

						<div className="empty" />
					</div>

					{status === 2 ||
						(status === 3 && (
							<p style={{ marginBottom: "20px" }}>
								Click the upload icon below to initate the batch file upload and
								run the process to analyze your data attributes.
							</p>
						))}

					<div className="upload-box">
						{status === 2 ? (
							<Uploading />
						) : status === 3 ? (
							<Upload update={handleUpdate} />
						) : null}
					</div>
					{status === 1 && (
						<Uploaded
							records={names.records}
							type={names.type}
							token={token}
							msg={setMsg}
						/>
					)}

					{msg.type && (
						<div>
							<Msg data={msg} />
							<Button
								label={"Reset Upload Form"}
								iconLeft={"fa-refresh"}
								name="copyLink"
								click={handleReset}
							/>
						</div>
					)}
				</form>
			</div>
		</>
	);
};

export default HotelUploadForm;
